// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentCreateModel {
    static getAttributeTypeMap() {
        return DocumentCreateModel.attributeTypeMap;
    }
}
DocumentCreateModel.discriminator = undefined;
DocumentCreateModel.additionalProperties = false;
DocumentCreateModel.attributeTypeMap = [
    {
        "name": "uploadSession",
        "baseName": "uploadSession",
        "type": "string"
    },
    {
        "name": "documentData",
        "baseName": "documentData",
        "type": "string"
    },
    {
        "name": "documentGroupSource",
        "baseName": "documentGroupSource",
        "type": "DocumentGroupSource"
    },
    {
        "name": "documentGroupReceivedDate",
        "baseName": "documentGroupReceivedDate",
        "type": "Date"
    },
    {
        "name": "documentOriginalFileName",
        "baseName": "documentOriginalFileName",
        "type": "string"
    },
    {
        "name": "documentPageCount",
        "baseName": "documentPageCount",
        "type": "number"
    },
    {
        "name": "transmissionType",
        "baseName": "transmissionType",
        "type": "TransmissionType"
    },
    {
        "name": "documentTypeId",
        "baseName": "documentTypeId",
        "type": "number"
    },
    {
        "name": "documentStatus",
        "baseName": "documentStatus",
        "type": "DocumentStatus"
    },
    {
        "name": "documentGroupStatus",
        "baseName": "documentGroupStatus",
        "type": "DocumentGroupStatus"
    },
    {
        "name": "faxAni",
        "baseName": "faxAni",
        "type": "string"
    },
    {
        "name": "faxDns",
        "baseName": "faxDns",
        "type": "string"
    },
    {
        "name": "intakeLayoutId",
        "baseName": "intakeLayoutId",
        "type": "number"
    },
];
//# sourceMappingURL=documentCreateModel.js.map